import React from 'react';
import { Stack } from '@mui/material';
import { AccessAlarm, PersonOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ServiceListMobileViewProps } from './ServiceListMobileView.props';
import { MiddleColumnWrapper, PriorityChipWrapper, RightColumnWrapper, IconWrapper,OuterWrapper, StyledMobileWrapper } from './ServiceListMobileView.styles';
import { Typography, TypographyFontWeightProps, TypographyVariantProps } from '../../atoms/Typography';
import { Chip } from '../../atoms/Chip';
import { SizeProps } from '../../../@types';
import { COLORS } from '../../../configs/colors';
import { getUnbreachedSLATimeout } from '../../../utils/services';

export const ServiceListMobileView: React.FC<ServiceListMobileViewProps> = ({ data }) => {
  const navigate = useNavigate();
  const slaTimeout = getUnbreachedSLATimeout(data?.clientSLASummary || '', data?.opsSLASummary || '');

  return (
    <StyledMobileWrapper onClick={() => navigate(`/services/${data?.serviceId}`)}>
      <Stack maxWidth={'30px'}>
        <img height={'30px'} src={data?.logoPic} alt={data?.clientHierarchy}/>
      </Stack>
      <MiddleColumnWrapper>
        <Typography variant={TypographyVariantProps.Caption} fontWeight={TypographyFontWeightProps.Bold}>{data?.locationName}</Typography>
        <Typography variant={TypographyVariantProps.Caption}>{data?.serviceZone}</Typography> 
        <Typography variant={TypographyVariantProps.Caption}>{data?.serviceParams}</Typography>
        <OuterWrapper>
          <IconWrapper>
            <PersonOutline fontSize="small" aria-label="Primary Allocation" sx={{ height: '15px', width: '15px' }}/>
          </IconWrapper>
          <Typography variant={TypographyVariantProps.Caption} textColor={COLORS.Black}>{data?.primaryAllocationNode || 'Unallocated'}</Typography>
        </OuterWrapper>
        <Typography variant={TypographyVariantProps.Caption} textColor={COLORS.Blue}>{data?.reportedFaultDescriptionCombine}</Typography>
        <OuterWrapper>
          <IconWrapper>
            <AccessAlarm fontSize="small" aria-label="SLA" sx={{ height: '15px', width: '15px' }}/>
          </IconWrapper>
          <Typography variant={TypographyVariantProps.Caption} fontWeight={TypographyFontWeightProps.Medium} textColor={slaTimeout ? COLORS.Green : ''}>{slaTimeout || 'Unscheduled'}</Typography>
        </OuterWrapper>
      </MiddleColumnWrapper>
      <RightColumnWrapper> 
        <Typography variant={TypographyVariantProps.Subtitle2} fontWeight={TypographyFontWeightProps.Bold}>{data?.serviceId}</Typography>
        <Typography variant={TypographyVariantProps.Caption}>{data?.reference1}</Typography>
        <Typography variant={TypographyVariantProps.Caption} fontWeight={TypographyFontWeightProps.Medium}>{data?.serviceStatusName}</Typography>
        <PriorityChipWrapper>
          <Chip size={SizeProps.Small} label={data?.priority?.shortName} backgroundColor={data?.priority?.color} borderColor={data?.priority?.color} textColor="#ffffff" />
        </PriorityChipWrapper>
        <Typography variant={TypographyVariantProps.Caption} fontWeight={TypographyFontWeightProps.Bold}>{data?.serviceTypeName}</Typography>
      </RightColumnWrapper>
    </StyledMobileWrapper>
  );
};